/** @format */
import Master from '../../Layouts/Master';
import ErrorMessage from '../../../Shared/Components/ErrorMessage';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import useApi from '../../../Shared/hooks/api/Index';
import { error, success } from '../../../Shared/Components/Toast';
import { useContext } from 'react';
import { EventContext } from '../../../Contexts/EventContext';
import { useEffect } from 'react';
import Loading from '../../../Shared/Components/Loading';
import { useParams } from 'react-router';

const validationSchema = Yup.object().shape({
	title: Yup.string()
		.required('عنوان الزامی است')
		.max(190, 'عنوان نمیتواند بیشتر از 190 کاراکتر باشد'),
	parent_id: Yup.number().typeError('رشته سنی الزامی است').nullable(),
});

const EditLevel = () => {
	const navigate = useNavigate();
	const { id } = useParams();
	const eventContext = useContext(EventContext);
	const [submitFormLoading, setSubmitFormLoading] = useState(false);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		getInfo();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const getInfo = async () => {
		setLoading(true);
		await useApi.get(
			'/panel/base/match-level?all=1',
			{},
			(res) => {
				eventContext.levels = res.data.data;
			},
			(err) => {
				console.log(err);
				error('هنگام دریافت اطلاعات خطایی رخ داده است.');
				setLoading(false);
			},
		);
		await useApi.get(
			`/panel/base/match-level/${id}`,
			{},
			(res) => {
				eventContext.level = res.data.data;
				setLoading(false);
			},
			(err) => {
				console.log(err);
				error('هنگام دریافت اطلاعات خطایی رخ داده است.');
				setLoading(false);
			},
		);
	};

	const onSubmitForm = async (values, setSubmitting) => {
		setSubmitFormLoading(true);

		await useApi.put(
			`/panel/base/match-level/${id}`,
			values,
			(res) => {
				success('مرحله با موفقیت ویرایش شد');
				navigate('/panel/base-define/match-level', { replace: true });
			},
			(err) => {
				setSubmitFormLoading(false);
				error('خطایی در ثبت اطلاعات پیش آمده است.');
			},
		);
	};

	return loading ? (
		<Loading />
	) : (
		<Master>
			<Formik
				initialValues={{
					title: eventContext?.level?.title,
					parent_id: eventContext?.level?.parent_id,
					status: eventContext?.level?.status,
				}}
				onSubmit={(values, { setSubmitting }) => {
					onSubmitForm(values, setSubmitting);
				}}
				validationSchema={validationSchema}>
				{({
					values,
					errors,
					handleChange,
					handleSubmit,
					isSubmitting,
					setFieldValue,
				}) => (
					<form onSubmit={handleSubmit}>
						<div className='row border rounded mt-3'>
							<div className='col-12'>
								<div className='form-group'>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>عنوان مرحله</label>
										<input
											name='title'
											value={values.title}
											onChange={handleChange}
											type='text'
											className='form-control'
										/>
										<ErrorMessage error={errors.title} />
									</div>
								</div>
							</div>

							{eventContext?.levels?.length > 0 && (
								<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
									<div className='form-group'>
										<div className='d-flex flex-column mt-1 mx-2'>
											<label>گروه</label>
											<select
												className='form-control'
												name='parent_id'
												onChange={handleChange}
												value={values.parent_id}>
												<option value={null}>اصلی</option>
												{eventContext?.levels?.map((item) => (
													<option value={item.id}>{item.title}</option>
												))}
											</select>
											<ErrorMessage error={errors.parent_id} />
										</div>
									</div>
								</div>
							)}

							<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
								<div className='form-group'>
									<div className='d-flex flex-column'>
										<label className='f-14 mx-2'>وضعیت</label>
										<select
											value={values.status}
											name='status'
											onChange={handleChange}
											className='form-control'>
											<option value='1'>فعال</option>
											<option value='0'>غیرفعال</option>
										</select>
										<ErrorMessage error={errors.status} />
									</div>
								</div>
							</div>
							<div className='col-12'>
								<div className='d-flex flex-row justify-content-end'>
									<button className='btn btn-info btn-sm f-14'>
										{submitFormLoading ? (
											<div
												className='spinner-border spinner-border-sm text-white mb-1'
												role='status'></div>
										) : (
											'ثبت مرحله'
										)}
									</button>
								</div>
							</div>
						</div>
					</form>
				)}
			</Formik>
		</Master>
	);
};

export default EditLevel;
